import React from "react";
import AppDownloadLayer from "./AppDownloadLayer";

const AppDownloadPage = () => {
    return (
        <>

            {/* AppDownloadLayer */}
            <AppDownloadLayer />

        </>
    );
};

export default AppDownloadPage; 
